module.exports = __webpack_public_path__ + "img/super-admin.6ca86639.svg";